import React from 'react'
import { Box, Grid } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

import { CONTENT_WRAPPER_SX } from '../constants.ts'

export const AuthLayout = (): React.ReactElement => {
  return (
    <Box sx={CONTENT_WRAPPER_SX}>
      <Box
        sx={{
          display: 'flex',
          minHeight: '70vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid container flexDirection="row" justifyContent="space-around" alignItems="center">
          <Grid item xs={12} lg={6}>
            <AnimatePresence mode="wait">
              <Outlet />
            </AnimatePresence>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
